import { inputClassName, labelClassName } from './constants';

export type CourseTextFieldsProps = {
  learningObjectives: string;
  setLearningObjectives: (v: string) => void;
  complianceTags: string;
  setComplianceTags: (v: string) => void;
};

export function CourseTextFields({
  learningObjectives,
  setLearningObjectives,
  complianceTags,
  setComplianceTags,
}: CourseTextFieldsProps) {
  return (
    <>
      {/* Learning objectives */}
      <div>
        <label htmlFor="course-objectives" className={labelClassName}>
          Objetivos de aprendizaje
        </label>
        <textarea
          id="course-objectives"
          value={learningObjectives}
          rows={2}
          onChange={(e) => setLearningObjectives(e.target.value)}
          className={inputClassName}
          placeholder="Objetivos de la capacitación..."
          maxLength={10000}
        />
      </div>

      {/* Compliance tags */}
      <div>
        <label htmlFor="course-tags" className={labelClassName}>
          Etiquetas de cumplimiento
        </label>
        <input
          id="course-tags"
          type="text"
          value={complianceTags}
          onChange={(e) => setComplianceTags(e.target.value)}
          className={inputClassName}
          placeholder="ISO 9001, BPMD, etc."
          maxLength={5000}
        />
      </div>
    </>
  );
}
